// Assumes browser environment with local storage
class LocalStorageStore {
  constructor(prefix
  /*: string*/
  , localStorage
  /*: any*/
  ) {
    this.prefix = prefix;
    this.localStorage = localStorage;
  }

  save(key
  /*: string*/
  , item
  /*: any*/
  ) {
    let jitem;

    try {
      jitem = JSON.stringify(item);
    } catch (error) {
      jitem = '';
    }

    this.localStorage.setItem(`${this.prefix}:${key}`, jitem);
  }

  load(key
  /*: string*/
  )
  /*: any*/
  {
    const jitem = this.localStorage.getItem(`${this.prefix}:${key}`);
    let item;

    try {
      item = JSON.parse(jitem);
      return item;
    } catch (error) {
      return '';
    }
  }

}

module.exports = LocalStorageStore;